// extracted by mini-css-extract-plugin
module.exports = {"rotation":"LandingNewsletterTemplate_rotation__PLwA_"};